import { render, staticRenderFns } from "./FlyoutCartBadge.vue?vue&type=template&id=0398ae00&"
import script from "./FlyoutCartBadge.vue?vue&type=script&lang=js&"
export * from "./FlyoutCartBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonplumb/pixelcabin/themes/lavazza-expert/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0398ae00')) {
      api.createRecord('0398ae00', component.options)
    } else {
      api.reload('0398ae00', component.options)
    }
    module.hot.accept("./FlyoutCartBadge.vue?vue&type=template&id=0398ae00&", function () {
      api.rerender('0398ae00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/FlyoutCart/FlyoutCartBadge.vue"
export default component.exports